'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var COMPANY = exports.COMPANY = 'COMPANY';
var USERS_AND_TEAMS = exports.USERS_AND_TEAMS = 'USERS_AND_TEAMS';
var OWNER = exports.OWNER = 'OWNER';


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/chat-heading-config/constants/ChatHeadingConfigTypes.js
// module id = 148
// module chunks = 2 3